import { connect } from 'react-redux';
import GameDetailPage from './game_detail';
import {
	getGameDetail,
	getAssignReferee,
	resetData,
	getTravelClaimPerformed,
	submitTravelClaim,
	getPerformanceReport,
	savePerformanceReport,
	submitPerformanceReport,
	publishPerformanceReport,
	confirmGameToOfficial,
	declineGameToOfficial
} from '../../../../../actions/game';

function mapsDispatchToProps(dispatch) {
	return {
		resetData: () => dispatch(resetData()),
		fetchGame: (id) => dispatch(getGameDetail(id)),
		getAssignReferee: (id) => dispatch(getAssignReferee(id)),
		getTravelClaimPerformed: (id) => dispatch(getTravelClaimPerformed(id)),
		submitTravelClaim: (id, data) => dispatch(submitTravelClaim(id, data)),
		getPerformanceReport: (id) => dispatch(getPerformanceReport(id)),
		savePerformanceReport: (id, data) => dispatch(savePerformanceReport(id, data)),
		submitPerformanceReport: (id, data) => dispatch(submitPerformanceReport(id, data)),
		publishPerformanceReport: (id, data) => dispatch(publishPerformanceReport(id, data)),
		confirmGameToOfficial: (id, callback) => dispatch(confirmGameToOfficial(id, callback)),
		declineGameToOfficial: (id, reason, callback) => dispatch(declineGameToOfficial(id, reason, callback))
	}
}

function mapsStateToProps(state) {
	return {
		game: state.game.game_detail,
		loading: state.game.is_loading,
		assign_referees: state.game.assign_referees,
		perf_report_data: state.game.perf_report_data,
		perf_report_loading: state.game.perf_report_loading,
		travel_claim: state.game.travel_claim,
		travel_claim_loading: state.game.travel_claim_loading
	}
}

export default connect(() => (mapsStateToProps), mapsDispatchToProps)(GameDetailPage);